// extracted by mini-css-extract-plugin
export default {"shortz_container":"ShortzVideoPlayer_shortz_container__KAyEm","shortz":"ShortzVideoPlayer_shortz__EGw8V","shortz_loading":"ShortzVideoPlayer_shortz_loading__4r8jb"};